var map = {
	"./A.svg": 339,
	"./B.svg": 340,
	"./C.svg": 341,
	"./CH.svg": 342,
	"./D.svg": 343,
	"./E.svg": 344,
	"./F.svg": 345,
	"./G.svg": 346,
	"./H.svg": 347,
	"./I.svg": 348,
	"./J.svg": 349,
	"./K.svg": 350,
	"./L.svg": 351,
	"./LL.svg": 352,
	"./M.svg": 353,
	"./N.svg": 354,
	"./O.svg": 355,
	"./P.svg": 356,
	"./Q.svg": 357,
	"./R.svg": 358,
	"./S.svg": 359,
	"./T.svg": 360,
	"./U.svg": 361,
	"./V.svg": 362,
	"./W.svg": 363,
	"./X.svg": 364,
	"./Y.svg": 365,
	"./Z.svg": 366,
	"./Ñ.svg": 367
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 338;